module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyOCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjk1ODQgMTguNzVWMC4yNUwwLjg1NDI0OCA5LjVMMTMuOTU4NCAxOC43NVpNMTQuNzI5MiA5LjVMMjcuODMzNCAxOC43NVYwLjI1TDE0LjcyOTIgOS41WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanclub/notes/prev.svg
// module id = 6/M5
// module chunks = 7